import _ from "lodash";

import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// material-ui components
import withStyles from "material-ui/styles/withStyles";

import ManagerRoute from './etc/ManagerRoute';
import { withRouter } from "react-router";
import Content from "./Content";
import Login from "./auth/components/Login";
import { graphql} from "react-apollo";
import gql from "graphql-tag";
import Loading from "./etc/Loading";

// core components
import Sidebar from "components/Sidebar/Sidebar.jsx";
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";

import dashboardRoutes from "../routes/dashboard.jsx";

import appStyle from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";
import image from "assets/img/sidebar-2.jpg";
import logo from "assets/img/appenLogoFinal.png";
import { stream_notification } from "../lib/thunderpush/client";
import Notification from './elements/Notifications';

let ps;

const query = gql`{
  currentUser{
    username
    password
    usertype
    phone
  }
}`

const withDataAndErrors = graphql(query, {
  options: {
    errorPolicy: 'all'
  }
});


class Dashboard extends React.Component {

  state = {
    mobileOpen: false,
    miniActive: false,
    notification: false,
    notificationData: {
      message: '',
      color: 'success',
      position: 'tr',
      count: 0
    }
  };

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  getRoute() {
    return this.props.location.pathname !== "/maps/full-screen-maps";
  }

  onNotificationsReceived(data) {
    console.log('onNotificationsReceived');
    console.log(data);
    let m = '';

    if (data['title'] && data['msg'])
      m = `${data['title']} - ${data['msg']}`;
    else
      m = data['msg'];

    let type = 'info';

    if (data['type'])
      type = data['type'];

    let pos = 'tr';
    const posConstants = ["tl", "tr", "tc", "br", "bl", "bc"];

    if (data['position'] && posConstants.includes(data['position']))
      pos = data['position'];

    let persistent = false;

    if (data['persistent'])
      persistent = data['persistent'];

    this.showNotification(m, type, pos, persistent);
  }

  componentWillMount() {
    const thunderKey = localStorage.getItem('THUNDERPUSH_KEY');
    const thunderHost = localStorage.getItem('THUNDERPUSH_HOST');

    if (thunderKey && thunderHost) {
      // stream_notification(
      //          localStorage.getItem('THUNDERPUSH_HOST'),
      //          localStorage.getItem('THUNDERPUSH_KEY'),
      //          localStorage.getItem('APN_USERID'),
      //          ['general_tp'],
      //          this.onNotificationsReceived.bind(this)
      //       );
    }
  }

  closeNotification(){
    this.setState({"notification": false});
  }

  showNotification(message, color, position, persistent){
    let c = this.state.notificationData.count;

    c++;
    this.state.notificationData.count = c;

    this.setState({
      "notification":true,
      'notificationData': {
        'message': message,
        'position': position,
        'color': color,
        'count': c
      }
    });

    if (!persistent) {
      setTimeout(
        function() {
          this.setState({
            "notification":false, 
            "notificationData": {
                        message: '',
                        color: 'success',
                        position: 'tr',
                        count: 0
                      }
          });
        }.bind(this),
        15000
      );
    }
  }

  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }    
  }

  componentDidUpdate(e) {
    if (!_.isEmpty(this.refs)) {
      if (e.history.location.pathname !== e.location.pathname) {
        this.refs.mainPanel.scrollTop = 0;
      }
      if (navigator.platform.indexOf("Win") > -1) {
        // eslint-disable-next-line
        ps = new PerfectScrollbar(this.refs.mainPanel, {
          suppressScrollX: true,
          suppressScrollY: false
        });
      }
    }
  }

  sidebarMinimize() {
    this.setState({ miniActive: !this.state.miniActive });
  }

  render() {
    const { notification, notificationData } = this.state;

    let notificationBar = null;

    if(this.props.data.loading){

      return(<Loading />)
    }

    let user = this.props.data.currentUser
    if (user == null){
      return (<div> {<Login history={this.props.history}/>} </div>);
    }

    const { classes, ...rest } = this.props;
    const mainPanel =
      classes.mainPanel +
      " " +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive,
        [classes.mainPanelWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1
      });

    if (notification){
      notificationBar = (
        <Notification
          message = {notificationData.message}
          close = {this.closeNotification.bind(this)}
          open = {notification}
          notifyCallback = {this.showNotification.bind(this)}
          position = {notificationData.position}
          color = {notificationData.color}
        />
      )
    }

    return (
      <div className={classes.wrapper}  className="container-fluid">
        <Sidebar
          routes={dashboardRoutes}
          logoText={"Telephony"}
          logo={logo}
          username={user.username}
          usertype={user.usertype}
          image={image}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color="blue"
          bgColor="black"
          miniActive={this.state.miniActive}
          {...rest}
        />
        <div className={mainPanel} ref="mainPanel">
          <Header
            sidebarMinimize={this.sidebarMinimize.bind(this)}
            miniActive={this.state.miniActive}
            routes={dashboardRoutes}
            handleDrawerToggle={this.handleDrawerToggle}
            history={this.props.history}
            newNotifCount={this.state.notificationData.count}
            {...rest}
          />

          {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          {this.getRoute() ? (
            <div className={classes.content}>
              {notificationBar}
              <div className={classes.container}>{<Content />}</div>
            </div>
          ) : (
            <div className={classes.map}>{<Content />}</div>
          )}
          {this.getRoute() ? <Footer fluid /> : null}
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(appStyle)(withRouter((withDataAndErrors)(Dashboard)));



// WEBPACK FOOTER //
// ./src/views/Dashboard.jsx